import { render, staticRenderFns } from "./QuotationButtons.vue?vue&type=template&id=099cbe10&scoped=true&lang=html"
import script from "./QuotationButtons.vue?vue&type=script&lang=js"
export * from "./QuotationButtons.vue?vue&type=script&lang=js"
import style0 from "./QuotationButtons.vue?vue&type=style&index=0&id=099cbe10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "099cbe10",
  null
  
)

export default component.exports